"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDownWithSearch = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var NO_RESULTS_KEY = '__ws-dropdown-with-search-no-results__';
/**
 * DropDownWithSearch wraps Fabric's ComboBox to provide a searchable
 * dropdown experience while keeping a familiar dropdown-like API.
 */
exports.DropDownWithSearch = function (_a) {
    var options = _a.options, onChange = _a.onChange, onInputValueChange = _a.onInputValueChange, _b = _a.noResultsText, noResultsText = _b === void 0 ? 'No matching options' : _b, _c = _a.autoComplete, autoComplete = _c === void 0 ? 'off' : _c, _d = _a.allowFreeform, allowFreeform = _d === void 0 ? true : _d, _e = _a.useComboBoxAsMenuWidth, useComboBoxAsMenuWidth = _e === void 0 ? true : _e, onMenuDismissed = _a.onMenuDismissed, rest = __rest(_a, ["options", "onChange", "onInputValueChange", "noResultsText", "autoComplete", "allowFreeform", "useComboBoxAsMenuWidth", "onMenuDismissed"]);
    var _f = react_1.useState(''), query = _f[0], setQuery = _f[1];
    var filteredOptions = react_1.useMemo(function () {
        var normalizedQuery = query.trim().toLowerCase();
        if (!normalizedQuery) {
            return options;
        }
        return options.filter(function (option) {
            var optionText = (option.text || '').toLowerCase();
            var optionKey = String(option.key || '').toLowerCase();
            return (optionText.indexOf(normalizedQuery) >= 0 || optionKey.indexOf(normalizedQuery) >= 0);
        });
    }, [options, query]);
    var visibleOptions = react_1.useMemo(function () {
        if (filteredOptions.length > 0) {
            return filteredOptions;
        }
        return [{ key: NO_RESULTS_KEY, text: noResultsText, disabled: true }];
    }, [filteredOptions, noResultsText]);
    return (react_1.default.createElement(office_ui_fabric_react_1.ComboBox, __assign({}, rest, { options: visibleOptions, autoComplete: autoComplete, allowFreeform: allowFreeform, useComboBoxAsMenuWidth: useComboBoxAsMenuWidth, onInputValueChange: function (value) {
            setQuery(value || '');
            if (onInputValueChange) {
                onInputValueChange(value);
            }
        }, onChange: function (event, option, index, value) {
            if (option && option.key === NO_RESULTS_KEY) {
                return;
            }
            if (onChange) {
                onChange(event, option, index, value);
            }
        }, onMenuDismissed: function () {
            setQuery('');
            if (onMenuDismissed) {
                onMenuDismissed();
            }
        } })));
};
